import { SET_SIDENAVIGATION } from '../constants/ActionTypes';

const sideNavigation = (state = {}, action) => {
    switch (action.type) {
        case SET_SIDENAVIGATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default sideNavigation;
